export default __webpack_public_path__ + "static/background+logo-51d76b22befcdf82295b032e75df2cab.jpg";